interface SpeakerAvatarProps {
  name: string;
  picture?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

function getInitials(name: string): string {
  const parts = name.split(' ');
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function getBackgroundColor(name: string): string {
  // Generate a consistent color based on the name
  const colors = [
    'bg-blue-500',
    'bg-green-500',
    'bg-purple-500',
    'bg-pink-500',
    'bg-indigo-500',
    'bg-teal-500',
    'bg-orange-500',
    'bg-cyan-500',
  ];

  const hash = name.split('').reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);

  return colors[Math.abs(hash) % colors.length];
}

export function SpeakerAvatar({
  name,
  picture,
  size = 'md',
  className = '',
}: SpeakerAvatarProps) {
  const sizeClasses = {
    sm: 'h-12 w-12 text-sm',
    md: 'h-16 w-16 text-base',
    lg: 'h-24 w-24 text-xl',
  };

  const baseClasses =
    'rounded-full object-cover ring-2 ring-gray-900 dark:ring-gray-200';
  const finalClasses = `${sizeClasses[size]} ${baseClasses} ${className}`;

  if (picture) {
    return <img src={picture} alt={name} className={finalClasses} />;
  }

  // Placeholder with initials
  const initials = getInitials(name);
  const bgColor = getBackgroundColor(name);

  return (
    <div
      className={`${finalClasses} ${bgColor} flex items-center justify-center font-semibold text-white`}
      aria-label={name}
    >
      {initials}
    </div>
  );
}
